import { BookOpen } from 'lucide-react';
import logo from '../../../img/logo.png'
import './loading.css';

export default function LoadingScreen() {
    return (
        <div className='loading_container'>
            
            <div className='logo_wrapper'>
                <img src={logo} style={{width:'50px'}}>
                </img>
            </div>
            
            <h1 className='loading_title'>EBD Chamadas</h1>
            
            <div className='loading_subtitle'>
                <svg 
                    className='spinner' 
                    xmlns="http://www.w3.org/2000/svg" 
                    width="18" 
                    height="18" 
                    viewBox="0 0 24 24" 
                    fill="none" 
                    stroke="currentColor" 
                    strokeWidth="3" 
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                >
                    <path d="M21 12a9 9 0 1 1-6.219-8.56" />
                </svg>
                A preparar a sua sala...
            </div>
            
        </div>
    );
}
